import AgreementOfTerms from './AgreementOfTerms';
import DirectorySearchAndDisplay from './DirectorySearchAndDisplay';
import { useDirectoryContext } from '../contexts/DirectoryContext';
import { useDirectorySearchContext } from '../contexts/DirectorySearchContext';
import Box from '@mui/material/Box';
import { CircularProgress } from '@mui/material';
import NoAccess from './NoAccess';

/**
 * DirectoryLandingPage Component
 * 
 * This component displays the member directory landing page, which changes based on the state of `hasAgreed` (agreement of terms).
 *
 * If the user is neither member nor aap staff, it displays the `NoRoles` component. 
 * If the user has not agreed to the terms, it displays the `AgreementOfTerms` component.
 * If the user has agreed to the terms and the directory context is still loading, it displays a loading spinner.
 * If the user has agreed to the terms and the directory context has finished loading, it displays the `DirectorySearchAndDisplay` component.
 * 
 * Example usage:
 * ```tsx
 * <DirectoryLandingPage />
 * ```
 * 
 * @returns {JSX.Element} The member directory landing page component.
 */
export default function DirectoryLandingPage() {
    const { loadingDirCtx, hasAccess } = useDirectoryContext();
    const { hasAgreed } = useDirectorySearchContext();

    if (!hasAccess) {
        return (<NoAccess />);
    }

    return (
        <Box className="directory-application" sx={{ display: 'inline' }}>
            {!hasAgreed && <AgreementOfTerms />}
            {hasAgreed && loadingDirCtx && <CircularProgress />}
            {hasAgreed && !loadingDirCtx && <DirectorySearchAndDisplay />}
        </Box>
    );
}
